module.exports = __webpack_public_path__ + "static/media/img-card-seven.d5cfea1a.jpg";